import React, {FC} from 'react';
import {BG} from 'constants/index';

import {ScrollSlowly} from '..';

import {Logos} from './logos';

import * as styles from './styles.module.scss';

type ScrollLogosProps = {
	bg?: BG
	title: string
	children?: React.ReactNode[]
}

export const ScrollLogos: FC<ScrollLogosProps> = ({
	title = 'FEATURED IN',
	children,
	...rest
}) => {
	const props = {
		...rest,
		title: <div className={styles.title}>{title}</div>,
		classNames: {
			panel: styles.panel,
			scroll: styles.scroll,
		},
	};

	return (
		<ScrollSlowly {...props}>
			{children || Logos}
		</ScrollSlowly>
	);
};
